module.exports = __webpack_public_path__ + "img/Weapon_52.e4a0b606.png";